import { CartLinesUpdateEvent } from '@shopify/events';

// Use the theme's standard cart event so its drawer, totals and bag stay in sync.
window.hiriwaAddToCart = async (form, payload, onProgress) => {
  const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(item => item.dataset.sectionId).filter(Boolean))];
  payload.set('sections', sections.join(','));
  payload.set('sections_url', window.location.pathname);
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: String(payload.get('id')), quantity: Number(payload.get('quantity')) || 1 }],
    promise: deferred.promise,
  }));
  const addButton = form.querySelector('[data-hw-add]') || form.querySelector('[type="submit"]');
  const buttonText = addButton?.querySelector('.form-control__button-text') || addButton;
  const originalLabel = buttonText?.textContent;
  if (buttonText) { buttonText.setAttribute('aria-live', 'polite'); buttonText.textContent = 'Adding…'; }
  try {
    const response = await new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('POST', Theme.routes.cart_add_url);
      request.setRequestHeader('Accept', 'application/json');
      request.responseType = 'json';
      if (onProgress) request.upload.addEventListener('progress', onProgress);
      request.addEventListener('load', () => {
        const data = request.response;
        if (request.status >= 200 && request.status < 300 && !data?.status) resolve(data);
        else reject(new Error(data?.description || data?.message || 'Could not add this item. Please try again.'));
      });
      request.addEventListener('error', () => reject(new Error('Please check your connection and try again.')));
      request.send(payload);
    });
    const cartResponse = await fetch(Theme.routes.cart_url + '.js', { credentials: 'same-origin' });
    if (!cartResponse.ok) throw new Error('Your item was added. Please open the bag to check your cart.');
    const cart = await cartResponse.json();
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
      items: cart.items, source: 'product-form-component', sourceId: form.id,
      itemCount: cart.item_count, sections: response.sections, didError: false,
    } });
    if (buttonText) buttonText.textContent = 'Added to Cart';
    document.getElementById('cart-drawer')?.open();
    return cart;
  } catch (error) {
    if (buttonText) buttonText.textContent = originalLabel;
    deferred.resolve({ detail: { didError: true } });
    throw error;
  }
};

document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
  if (form.querySelector('[data-hw-file-group]') || form.closest('product-form-component')) return;
  form.dataset.hwNativeCart = "ready";
  let busy = false;
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const payload = new FormData(form);
    const button = form.querySelector('[data-hw-add]') || form.querySelector('[type="submit"]');
    const status = form.querySelector('.hw-native-cart-status') || Object.assign(document.createElement('p'), { className: 'hw-native-cart-status' });
    status.setAttribute('role', 'status');
    if (!status.parentElement) form.append(status);
    busy = true;
    if (button) button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try { await window.hiriwaAddToCart(form, payload); status.textContent = ''; }
    catch (error) { status.textContent = error.message; }
    finally { busy = false; if (button) button.disabled = false; form.removeAttribute('aria-busy'); }
  });
});
